
<template>
  <div id="history_full_data" class="column history_full_data">
    <div class="history_full_data_title tal_c">
      <h1 class="text_lg fat upper main_blue_dk_fill">
        {{ $t("msg.transaction_details") }}
      </h1>
    </div>
    <!-- ..................................................................... -->
    <div class="cointainer_sm combo_1">
      <div class="history_full_data_data split_half_text">
        <span class="tal_l_b">
          <strong>{{ $t("msg.txid") }}:</strong>
        </span>

        <span v-if="transactionData.tokenTxid">
          <a
            :title="$t('msg.details')"
            :href="
              'https://bscscan.com/tx/' +
              transactionData.tokenTxid
            "
            target="blank_"
          >
            {{ transactionData.tokenTxid }}
          </a>
        </span>
      </div>

      <!-- transactionData.sourceCurrency.symbol -->

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.targetAmount"
      >
        <p>
          <span class="tal_l_b">
            <strong v-if="transactionData.type == 'purchase'"
              >{{ $t("msg.quantity") }} (BLUE):</strong
            >
          </span>
          <span class="tal_r_b"
            >{{ ((transactionData.targetAmount * transactionData.targetPrice - transactionData.sourceFee) / transactionData.targetPrice).toFixed(6) }}
            {{ symbAjust(transactionData.targetCurrency.symbol) }}</span
          >
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="!transactionData.triggerType"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.price") }}:</strong>
          </span>
          <span
            class="tal_r_b"
            v-if="
              transactionData.targetPrice &&
              transactionData.sourceCurrency.symbol
            "
            >{{ transactionData.targetPrice.toFixed(8) }}
            {{ transactionData.sourceCurrency.symbol }}</span
          >
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.sourceAmount"
      >
        <p>
          <span class="tal_l_b">
            <strong v-if="transactionData.type == 'purchase'"
              >{{ $t("msg.subtotal") }}:</strong
            >
          </span>
          <span class="tal_r_b"
            >{{
              getTotalFee(
                transactionData.targetAmount,
                transactionData.targetPrice,
                transactionData.sourceFee
              )
            }}
            {{ transactionData.sourceCurrency.symbol }}</span
          >
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="!transactionData.triggerType"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $tc("msg.fee", 1) }}:</strong>
          </span>
          <span class="tal_r_b" v-if="transactionData.sourceFee"
            >{{ transactionData.sourceFee.toFixed(8) }}
            {{ transactionData.sourceCurrency.symbol }}</span
          >
        </p>
      </div>

      

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.sourceAmount"
      >
        <p>
          <span class="tal_l_b">
            <strong v-if="transactionData.type == 'purchase'"
              >{{ $t("msg.total") }}:</strong
            >
          </span>
          <span class="tal_r_b"
            >{{
              getTotal(
                transactionData.targetAmount,
                transactionData.targetPrice
              )
            }}
            {{ transactionData.sourceCurrency.symbol }}</span
          >
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.amount"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.amount") }}:</strong>
          </span>
          <span class="tal_r_b" v-if="!transactionData.triggerType">
            {{ transactionData.amount }}
          </span>
          <span class="tal_r_b" v-else>{{ transactionData.amount }} BLU</span>
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.status"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.status") }}:</strong>
          </span>
          <span class="tal_r_b">{{ $t(`msg.${transactionData.status}`) }}</span>
        </p>
      </div>
      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.type"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.type") }}:</strong>
          </span>
          <span class="tal_r_b">{{ $t(`msg.${transactionData.type}`) }}</span>
        </p>
      </div>
      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.triggerType"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.type") }}:</strong>
          </span>
          <span class="tal_r_b">{{
            $t(`msg.${transactionData.triggerType}`)
          }}</span>
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.createdAt"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.createdAt") }}:</strong>
          </span>
          <span class="tal_r_b">
            {{ formatDate(transactionData.createdAt) }}
          </span>
        </p>
      </div>

      <div
        class="history_full_data_data split_half_text"
        v-if="transactionData.updatedAt"
      >
        <p>
          <span class="tal_l_b">
            <strong>{{ $t("msg.updatedAt") }}:</strong>
          </span>
          <span class="tal_r_b">
            {{ formatDate(transactionData.updatedAt) }}
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import spacetime from "spacetime";

export default {
  props: ["transactionData"],
  created() {},
  mounted() {},
  data: () => ({}),
  components: {},
  methods: {
    async cancelPurchase(id) {
      this.$emit("updateCancelled", id);
    },

    getTotal(total, price) {
      // let sum = 0;
      // if (total > 0 && fee) {
      //   sum = total + fee;
      //   return sum.toFixed(8);
      // }
        let totalT = total * price
        return totalT.toFixed(6)


    },

    getTotalFee(total, price, fee) {
        let totalT = total * price
        totalT = totalT - fee
        return totalT.toFixed(6)
    },

    symbAjust(el){
      if(el == 'blu' || el == 'BLU'){
        return "BLUE"
      }else{
        return el
      }
    },
    formatDate(value) {
      return spacetime(value).format("dd/MM/yyyy HH:mm:SS");
    },
  },
  computed: {},
  watch: {},
};
</script>
<style lang="css">
</style>


// WEBPACK FOOTER //
// src/components/private/transactions/TransactionDetails.vue